import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "10px",
    padding: "10px",
  },
  container: {
    marginTop: "30px",
    padding: "10px",
    marginBottom: "30px",
  },
  wrapper: {
    paddingLeft: 4,
    paddingRight: 4,
    marginBottom: 15,
    "@media(min-width: 280px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 320px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 360px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 400px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 600px)": {
      width: "calc(100%/3)",
      height: "100%",
    },
    "@media(min-width: 960px)": {
      width: "calc(100%/4)",
      height: "100%",
    },
  },
  card: {
    height: "100%",
    borderRadius: 5,
    boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
  },
  img: {
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(min-width: 280px)": {
      height: 128,
    },
    "@media(min-width: 320px)": {
      height: 148,
    },
    "@media(min-width: 360px)": {
      height: 168,
    },
    "@media(min-width: 960px)": {
      height: 270,
    },
  },
  contentWrapper: {
    height: 60,
    position: "relative",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "0px 15px",
    marginTop: 8,
    justifyContent: "space-between",
    height: 60,
  },
  title: {
    fontWeight: 700,
    fontSize: 14,
    textAlign: "center",
    color: "#333333",
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "@media(min-width: 280px)": {
      fontSize: 12,
    },
    "@media(min-width: 320px)": {
      fontSize: 12,
    },
    "@media(min-width: 360px)": {
      fontSize: 14,
    },
    "@media(min-width: 960px)": {
      fontSize: 14,
    },
  },
  price: {
    fontWeight: 700,
    fontSize: 12,
    color: "#eb6669",
    textAlign: "center",
    maxWidth: 139,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "@media(max-width: 280px)": {
      width: 100,
    },
    "@media(min-width: 960px)": {
      maxWidth: 150,
    },
  },
  btnWrap: {
    margin: 8,
    marginBottom: 12,
  },
  btn: {
    color: "#ffff",
    fontWeight: 700,
    fontSize: 12,
    "@media(max-width: 280px)": {
      padding: "4px 4px",
    },
    textTransform: "capitalize",
  },
  empty: {
    backgroundColor: "hsla(0,0%,100%,.9)",
    width: "100%",
    height: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  txtEmpty: {
    fontSize: 18,
    fontWeight: 700,
    color: "rgba(0,0,0,.4)",
  },
  boxButton: {
    display: "flex",
    flexDirection: "row",
    height: 50,
    maxWidth: "100%",
    width: 960,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    margin: "0 auto",
    paddingLeft: 30,
    // paddingRight: 30,
    zIndex: 999,
    // backgroundColor: "#5675D3",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  },
  buttonSelect: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    width: "40%",
    marginLeft: -30,
    cursor: "pointer",
  },
  buttonSelect1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "90%",
    backgroundColor: "#5675D3",
    cursor: "pointer",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  },
  txtStockTersedia: {
    fontSize: 12,
    color: "#777777",
    "@media (max-width: 360px)": {
      fontSize: 10,
    },
  },
  txtStock: {
    fontSize: 11,
    "@media (max-width: 360px)": {
      fontSize: 9,
    },
  },
}));

export default useStyles;
